import { render, staticRenderFns } from "./RequestRemontPositionField.vue?vue&type=template&id=6518fbf0&"
import script from "./RequestRemontPositionField.vue?vue&type=script&lang=js&"
export * from "./RequestRemontPositionField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QChip,QAvatar} from 'quasar'
component.options.components = Object.assign({QChip,QAvatar}, component.options.components || {})
